/*
 * @Description:
 * @Date: 2020-06-04 14:25:14
 */
import Vue from 'vue';
import Dialog from './main.vue';
import store from '@/store/index.js';
import router from '@/router/index';
const DialogConstructor = Vue.extend({ ...Dialog, store, router });
let instances = new Map();

const remove = uid => {
  return () => {
    let instancesSize = instances.size;
    if (!instancesSize) {
      throw new Error('没有 xrkDialog实例');
    }
    let keys = [...instances.keys()];
    let lastKey = keys[keys.length - 1];
    let example = instances.get(uid || lastKey); // 如果没有uid则删除最后一个
    document.getElementById('app').removeChild(example.$el);
    example.$destroy();
    instances.delete(example._uid);
  };
};

const initInstance = () => {
  let instance = new DialogConstructor({
    el: document.createElement('div'),
    store,
    router
  });
  let { _uid } = instance;
  instances.set(_uid, instance);
  instance.remove = remove(_uid);
  return instance;
};

const xrkDialog = function(options) {
  let instance = initInstance();

  for (let prop in options) {
    if (options.hasOwnProperty(prop)) {
      instance[prop] = options[prop];
    }
  }
  // 直接使用当前调用绑定父级
  if (this) {
    instance.$parent = this;
  }
  instance.$mount();
  document.getElementById('app').appendChild(instance.$el);
  Vue.nextTick(() => {
    instance.visible = true;
  });
  return instance;
};

xrkDialog.clear = () => {
  instances.forEach(item => {
    document.getElementById('app').removeChild(item.$el);
    item.$destroy();
  });
  instances.clear();
};

xrkDialog.remove = remove();

export default xrkDialog;
